import { POST } from '@/api'
import { isEqual } from 'lodash'

const INITIAL_VISIT = {
  id: null,
  reserveDate: null,
  startTime: null,
  endTime: null,
  options: {},
}

export default {
  namespaced: true,
  state: {
    visit: { ...INITIAL_VISIT },
    busy: false,
  },
  getters: {
    getDetail: (state, getters, { stores, customers }) => id => {
      const schemas = stores.current.store.optionsSchema.visitHistory
      const defaultOptions =
        schemas && schemas.reduce((options, schema) => Object.assign(options, { [schema.id]: null }), {})
      if (!id) return { ...INITIAL_VISIT, options: defaultOptions }
      const { date, time, options } = customers.detail.visits.list.find(v => v.id === id) || {}
      if (!options) return { ...INITIAL_VISIT, options: defaultOptions }
      const [startTime, endTime] = time.split(/[～〜]/)
      return {
        id,
        reserveDate: date,
        startTime: startTime || null,
        endTime: endTime || null,
        options: { ...defaultOptions, ...options },
      }
    },
    origin: ({ visit }, { getDetail }) => getDetail(visit.id),
    changed: ({ visit }, { origin }) => !isEqual(visit, origin),
  },
  mutations: {
    set(state, visit) {
      state.visit = { ...INITIAL_VISIT, ...visit, options: { ...INITIAL_VISIT.options, ...visit.options } }
    },
    update(state, visit) {
      state.visit = { ...state.visit, ...visit, options: { ...state.visit.options, ...visit.options } }
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async start(store, id) {
      const { commit, getters } = store
      commit('set', getters.getDetail(id))
    },
    async save(store) {
      const { commit, state, rootState } = store
      if (state.busy) return false
      commit('busy', true)

      const { id, options, ...visit } = state.visit

      const { status, message } = await POST('/api/web/customer/visit_history/regist', {
        ...visit,
        historyId: id,
        customerId: rootState.customers.edit.customer.id,
        options: Object.keys(options).map(key => ({ id: +key, value: options[key] })),
      })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
